import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const ReportProblemSuccessModalStyles = () => {
  const theme = useTheme();

  return {
    wrapper: {
      p: 3,
      borderRadius: "8px",
      border: `1px solid ${theme.palette.grey[200]}`,
      width: "100%",
    },
    content: {
      description: {
        wordBreak: "break-word",
      },
    },
  };
};
